<div class="switch-banner-container">
    <xm-media-image [imageOptions]="imageOptions" size="height" center="auto" class="icon"></xm-media-image>
    <h2>{{ header }}</h2>
    <p class="description-text">{{ description }}</p>
    <a *ngIf="cta?.content" (click)="onCtaClick()" class="xm-btn-link-dark cta-link">{{ cta.content }}</a>
</div>
